// Change your display name on tha landing display
const header = {
    name: "Ademola",
}
const background = {
    // Options: Snow or Particle
    type: "Particle"
}
// Write a para about yourself here
// To update your image, go to './styles/images.css'
const about = {
    paragraph: " Hello, I am Ademola Ogunmokun. I am higly analytical individual, a web developer and problem solver. I am passionate about building and providing solutions to people and/or organization through technology. I am skilled in Python and JavaScript programming languages. Additionally, I am confident working with various web technologies and frameworks such as HTML, CSS, Git, JQuery and Django web framework. I am currently learning Vue.js. "}
// Edit your skill and the percentage you know about it
// To Add a skill, copy any one below and paste it after the last comma
const skillsBar = [
    {
        name: "HTML5",
        value: 80
    },{
        name: "CSS3",
        value: 80
    },{
        name: "Javascript",
        value: 65
    },{
        name: "Python",
        value: 80
    },{
        name: "Django",
        value: 80
    },
    
    { 
        name: "Git",
        value: 65


    },
    {
        name: "Vue",
        value: 50
    },
]
// Edit your projects, its name, your skills used to make it, and the url. 
// You can omit freely anything if you dont have it
// To Add a Project, copy any one below and paste it after the last comma and increment the id's project number
const projects = [
    {
        // Add image in './styles/images.css' in #project1
        id: "project1",
        name: "Terrarium game",
        skills: ["HTML, CSS, JS"],
        url: "https://ademola101.github.io/Terrarium"
    },
    {
        // Add image in './styles/images.css' in #project2
        id: "project2",
        name: "Education forum board",
        skills: ["HTML, CSS, JS, Python, Django"],
        url: "https://github.com/Ademola101/My-Django-project-"
    },
    {
        // Add image in './styles/images.css' in #project3
        id: "project3",
        name: "Django admin extension functionality(user metrics, email functionality, etc.)",
        skills: ["HTML, CSS, JS, Python, Django"],
        url: "https://github.com/Ademola101/Django-back-end-extension-"
    },
    {
        // Add image in './styles/images.css' in #project4
        id: "project4",
        name: "Carbon Trigger Browser Extension",
        skills: ["HTML, CSS, JS"],
        url: "https://github.com/Ademola101/Carbon-trigger"
    },
    {
        // Add image in './styles/images.css' in #project5
        id: "project5",
        name: "Typing game",
        skills: ["HTML, CSS, JS"],
        url: "https://ademola101.github.io/typing-game/"
    },
]
// Edit your Miscellaneous Activities, its name and the url. 
// You can omit freely anything if you dont have it
// To Add a Activity, copy any one below and paste it after the last comma and increment the id's Miscellaneous number
const miscellaneous = [
    //{
        // Add image in './styles/images.css' in #misc1
      //  id: "misc1",
        //name: "Miscellaneous 1",
        //url: "https://github.com/kaustubhai"
    //},
    
]
// Contact form text, and Jotforms link
// To get your own jotform link, go to https://www.jotform.com/
// If you hacve the link already, paste it in the contactUrl below
const contact = {
    pitch: "Kindly get in touch with me through any of my below socials or the form  . Peace!!",
    copyright: "Ademola Ogunmokun",
    contactUrl: 'form.jotform.com/210244945360552'
}
// Paste your respective social media links. You can omit any if you dont have it
// Upload your resume in your drive, get the shaareable link and paste it in the resume section
const social = {
    github: 'https://github.com/Ademola101',
    facebook: 'https://facebook.com/isreal4desmond',
    linkedin: 'https://linkedin.com/in/ademola-ogunmokun',
    //resume: 'https://novoresume.com/',
    twitter: 'https://twitter.com/ademola_isr'
}
// Dont change anything here
export { header, background, about, skillsBar, projects, miscellaneous, contact, social }